import { useTypewriter } from "@/hooks/useTypewriter";

interface HeroProps {
  onOpenAuth: () => void;
}

const TYPED_WORDS = ["开箱即用", "一行命令", "复制即装", "秒级上手"];

export function Hero({ onOpenAuth }: HeroProps) {
  const typed = useTypewriter(TYPED_WORDS);

  return (
    <header className="hero">
      <div className="hero-glow" aria-hidden="true" />
      <div className="container hero-content">
        <div className="hero-badge">
          <span className="hero-badge-dot" />
          <span>让 AI 工具人人可用</span>
        </div>
        <h1 className="hero-title">
          <span className="hero-title-static">AI 智能体，</span>
          <span className="hero-typed gradient-text">{typed}</span>
          <span className="hero-caret" aria-hidden="true" />
        </h1>
        <p className="hero-desc">
          <strong>Agentfly</strong> 把复杂的环境配置做成一条命令。
          <br />
          不会配 Python、Node、WSL 或模型通道也没关系 ——
          复制、回车、等待完成，主流 AI 智能体直接可用。
        </p>
        <div className="hero-actions">
          <a
            href="#console"
            className="btn-primary"
            onClick={(ev) => {
              ev.preventDefault();
              onOpenAuth();
            }}
          >
            登录控制台
            <span aria-hidden="true">→</span>
          </a>
          <a href="#market" className="btn-secondary">应用市场</a>
        </div>

        <div className="hero-terminal">
          <div className="terminal">
            <div className="terminal-header">
              <span className="terminal-dot" />
              <span className="terminal-dot" />
              <span className="terminal-dot" />
              <span className="terminal-title">~ — agentfly install</span>
            </div>
            <div className="terminal-body">
              <div className="terminal-line">
                <span className="terminal-prompt">$</span>
                <span className="terminal-cmd">
                  {"curl -fsSL https://agentfly.net/install.sh | bash -s -- --token=<TOKEN>"}
                </span>
              </div>
              <div className="terminal-line">
                <span className="terminal-output">↳ 检测平台：<span className="t-accent">macos-arm64</span></span>
              </div>
              <div className="terminal-line">
                <span className="terminal-output">↳ 校验授权 ………………… <span className="t-ok">ok</span></span>
              </div>
              <div className="terminal-line">
                <span className="terminal-output">↳ 下载智能体 ………………… <span className="t-ok">ok</span></span>
              </div>
              <div className="terminal-line">
                <span className="terminal-output">↳ 完成安装 ……………………… <span className="t-ok">ok</span></span>
              </div>
              <div className="terminal-line">
                <span className="terminal-prompt">$</span>
                <span className="terminal-cmd">claude --version</span>
              </div>
              <div className="terminal-line">
                <span className="terminal-output">2.1.121 (Claude Code)</span>
              </div>
              <div className="terminal-line">
                <span className="terminal-comment"># 智能体已就位，新手也可以直接开始使用</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
